/* global ol */

var angular = require('angular');

var storageKey = 'saturatedMap';

function SaturationControl(googleMaps, storage) {
  this.googleMaps = googleMaps;
  this.storage = storage;
  this.control = this.initControl();

  this.saturated = false;
  if (this.storage.local.get(storageKey)) {
    this.toggleSaturation();
  }
}

SaturationControl.prototype.initControl = function() {
  this.$element = angular.element(
    '<div class="ol-saturation ol-unselectable ol-control"><button type="button" /></div>'
  );

  this.$element.find('button').on('click', this.toggleSaturation.bind(this));

  return new ol.control.Control({
    element: this.$element[0]
  });
};

SaturationControl.prototype.toggleSaturation = function() {
  this.saturated = ! this.saturated;
  this.storage.local.set(storageKey, this.saturated);
  this.googleMaps.toggleSaturation(this.saturated);
  this.$element.toggleClass('saturated', this.saturated);
};

module.exports = SaturationControl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/saturationControl.js
 ** module id = 189
 ** module chunks = 1
 **/